import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    field: 'name',
    label: 'filter.full name',
    type: 'text',
  },
  {
    field: 'phone',
    label: 'filter.phone',
    type: 'text',
  },
  {
    field: 'email',
    label: 'filter.e-mail',
    type: 'text',
  },
]
